import { Link, useParams } from 'react-router-dom';
import { GitBranch, Plus } from 'lucide-react';
import { useEffect } from 'react';
import { useStore } from '../../store/StoreContext';
import { ScreenHeader } from '../../components/ui/ScreenHeader';
import { AppCard } from '../../components/ui/AppCard';
import { IconButton } from '../../components/ui/IconButton';
import { EmptyState } from '../../components/ui/EmptyState';

export function WorkflowListScreen() {
  const { channelId } = useParams();
  const { channel, ensureChannelLoaded } = useStore();

  // Same fallback ChatScreen.tsx/ChannelDetailsScreen.tsx use: a channel
  // reached straight from its URL (or before the app's initial channels
  // sync has finished - see updateWorkflow's identical race, fixed in
  // StoreContext.patchChannel) isn't in `channels` yet. Without this, a
  // workflow saved on a cold load landed nowhere - patchChannel found no
  // matching channel to update at all.
  useEffect(() => {
    ensureChannelLoaded(channelId ?? '');
  }, [channelId, ensureChannelLoaded]);

  const c = channelId ? channel(channelId) : undefined;
  const workflows = c?.workflows ?? [];

  return (
    <div className="flex flex-col gap-4">
      <ScreenHeader
        title="Workflows"
        action={
          <Link to={`/channels/${channelId}/workflows/new`}>
            <IconButton icon={Plus} variant="filled" />
          </Link>
        }
      />
      <span className="text-sm text-black/50 dark:text-white/50 -mt-3">Triggers and actions</span>

      {workflows.length === 0 ? (
        <EmptyState icon={GitBranch} title="No workflows" subtitle="Create automation for this channel." />
      ) : (
        <div className="flex flex-col gap-3">
          {workflows.map((w) => (
            <Link key={w.id} to={`/channels/${channelId}/workflows/${w.id}`}>
              <AppCard className="flex flex-col gap-1">
                <span className="font-semibold">{w.title}</span>
                <span className="text-xs text-black/50 dark:text-white/50">{w.nickname}</span>
                <span className="text-[15px]">{w.trigger}</span>
                <span className="text-xs text-black/40 dark:text-white/40">
                  {w.actions.length} actions · {w.active ? 'Active' : 'Paused'}
                </span>
              </AppCard>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
